import React, { createContext, useContext, useState, useEffect } from 'react';

// Phase 1 landing port (Jun 2026): the legacy `translations` dictionary and
// its `t()` / `toggleLanguage` / `direction` exports were removed — every key
// was grep-verified dead (all consumers destructure `language` only and carry
// their own copy, e.g. LandingPage COPY, OrganizationSettings local t(en, ar)).

const LanguageContext = createContext(undefined);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('legal-advisor-language');
    return saved || 'en';
  });

  useEffect(() => {
    localStorage.setItem('legal-advisor-language', language);
    // Cluster B-6 (Feb 06 2026): set document.documentElement.dir so
    // CSS pseudo-elements and component libraries that read `[dir=rtl]`
    // from the root (popover positioning, Floating UI, etc.) trigger.
    // Component-tree `<div dir={...}>` patterns still cover content
    // direction; this adds the missing root-level signal.
    document.documentElement.lang = language;
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
